import styled from 'styled-components'
import { breakpoint } from 'utils'

export const Wrapper = styled.section`
  margin-bottom: 24px;

  padding: 24px;
  display: flex;
  flex-direction: column;

  font-size: ${({ theme }) => theme.fontSizes.small};
  line-height: 1.4;
  border-radius: ${({ theme }) => theme.radii.xxxlarge};

  color: ${({ theme }) => theme.colors.foreground.secondary[3]};

  ${breakpoint('sm')`
    margin-bottom: 64px;
  `}

  a:not([class]) {
    text-decoration: underline;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    color: ${({ theme }) => theme.colors.foreground.secondary[2]};
  }
`

export const Title = styled.h1`
  margin: 0 0 4px 0;

  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.large};
  line-height: 1.6;

  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`

export const ActionWrapper = styled.div`
  margin-top: 16px;
`
